import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, FormControlLabel, Checkbox, Divider, Grid, CircularProgress } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import CustomButton from "../common/CustomButton";
import CustomTextField from "../common/CustomTextField";
import CustomAutocomplete from '../common/CustomAutoComplete';
import { ClearRounded, SaveRounded } from "@mui/icons-material";
import { getStates, getCities, getCountries } from "../../services/CommonServices";
import CustomTextarea from '../common/CustomTextarea';
import { Update_Lead_leadId, GET_Lead_leadId } from '../../services/apiRoutes';
import CustomStyle from '../common/CustomStyle';
import CustomMobileField from '../common/CustomMobileField';
import { t } from '../../constants/translationHelper';


const leadValidationSchema = Yup.object().shape({
    leadOwner: Yup.string().required('Lead Owner is required'),
    clientCompanyId: Yup.string().required('Company is required'),
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    title: Yup.string().required('Title is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    mobile: Yup.string()
        .required('Mobile is required'),
    leadSourceId: Yup.string().required('Lead Source ID is required'),
    leadStatusId: Yup.string().required('Lead Status ID is required'),
    industry: Yup.string().required('Industry is required'),
    expectedDate: Yup.date().required('Expected Date is required'),
    street: Yup.string().required('Street is required'),
    countryId: Yup.string().required('Country ID is required'),
    stateId: Yup.string().required('State ID is required'),
    cityId: Yup.string().required('City ID is required'),
    businessGroup: Yup.number().required('business Group is required').integer('businessGroupId ID must be an integer'),

});

const UpdateLeads = ({ handleClose, industryType, rating, leadSource, leadStatus, conutries, businessGroup, leadId, getLeadList, setMessage, clientCompany, leadOwner, titles }) => {

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const countriesData = await getCountries();
                setCountries(countriesData || []);
            } catch (error) {
                console.error("Error fetching countries:", error);
            }
        };

        fetchCountries();
    }, []);
    const getCommonData = async () => {
        const getCountriesData = await getCountries();
        if (getCountriesData) {
            setCountries(getCountriesData);
        }
    }
    useEffect(() => {
        getCommonData();
    }, []);




    useEffect(() => {
        if (!leadId) return;

        const fetchData = async () => {
            try {
                const accessToken = sessionStorage.getItem('accessToken');

                const response = await axios.get(GET_Lead_leadId(leadId), {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,

                    },
                });

                setData(response.data.lead);

                const companyData = response.data.lead;
                setData(companyData);
                if (companyData?.country?.id) {
                    const stateData = await getStates({ id: companyData.country.id });
                    setStates(stateData || []);
                }
                if (companyData?.state?.id) {
                    const cityData = await getCities({ id: companyData.state.id });
                    setCities(cityData || []);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [leadId]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const accessToken = sessionStorage.getItem('accessToken');

            const response = await axios.put(Update_Lead_leadId(leadId), values, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "Lead Update successfully",
                    type: "success",
                });
                getLeadList()
                setTimeout(() => {
                    handleClose()
                }, 3000)
                handleClose()


            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };

    const handleChangeCountry = async (newValue, setFieldValue) => {
        const countryId = newValue?.id || "";
        setFieldValue("countryId", countryId);
        setFieldValue("stateId", "");
        setFieldValue("cityId", "");
        setStates([]);
        setCities([]);

        if (countryId) {
            try {
                const stateData = await getStates({ id: countryId });
                setStates(stateData || []);
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        }
    };

    const handleChangeState = async (newValue, setFieldValue) => {
        const stateId = newValue?.id || "";
        setFieldValue("stateId", stateId);
        setFieldValue("cityId", "");
        setCities([]);

        if (stateId) {
            try {
                const cityData = await getCities({ id: stateId });
                setCities(cityData || []);
            } catch (error) {
                console.error("Error fetching cities:", error);
            }
        }
    };
    return (
        <>
            <Box sx={{ mx: 'auto', mt: 0 }}>
                <Formik
                    initialValues={{
                        leadOwner: data?.leadOwner || '',
                        leadOwner: data?.leadOwner ? parseInt(data.leadOwner) : '',
                        title: data?.title ? parseInt(data.title) : '',
                        firstName: data?.firstName || '',
                        lastName: data?.lastName || '',
                        annualRevenue: data?.annualRevenue || '',
                        email: data?.email || '',
                        phone: data?.phone || '',
                        mobile: data?.mobile || '',
                        phonecodeId: parseInt(data?.phonecodeId || ''),
                        leadSourceId: data?.leadSourceId || '',
                        leadStatusId: data?.leadStatusId || '',
                        industry: data?.industry ? parseInt(data.industry) : '',
                        numberOfEmployees: data?.numberOfEmployees,
                        rating: data?.rating ? parseInt(data.rating) : '',
                        expectedDate: data?.expectedDate || '',
                        emailOptOut: data?.emailOptOut ? 1 : 0,
                        businessGroup: data?.businessGroup ? parseInt(data.businessGroup) : '',
                        secondaryEmail: data?.secondaryEmail || '',
                        street: data?.street || '',
                        countryId: data?.countryId || '',
                        clientCompanyId: data?.clientCompanyId || '',
                        stateId: data?.stateId || '',
                        cityId: data?.cityId || '',
                        zipCode: data?.zipCode || '',
                        description: data?.description || '',
                    }}
                    validationSchema={leadValidationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
                        <Form>
                            <Grid container spacing={1} style={CustomStyle.container}>
                                <Grid item xs={4} md={2}>
                                    <Typography sx={{ fontWeight: 600 }} style={CustomStyle.title}>
                                        {t("Update Leads")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} md={10} style={CustomStyle.buttonContainer}>
                                    <Box style={CustomStyle.buttonBox}>
                                        <CustomButton
                                            startIcon={<SaveRounded />}
                                            title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                            size="small"
                                            variant="contained"
                                            type="submit"
                                            disabled={isSubmitting}
                                        />

                                        <CustomButton
                                            startIcon={<ClearRounded />}
                                            title="Cancel"
                                            size="small"
                                            variant="contained"
                                            onClick={handleClose}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>

                            <Divider />
                            <Grid container spacing={1} style={{ paddingLeft: "5%", paddingRight: "5%", paddingTop: '5px' }}>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomAutocomplete
                                        options={leadOwner}
                                        fieldLabel="Lead Owner"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={leadOwner.find((option) => option.id === values.leadOwner) || null}
                                        onChange={(e, newValue) => setFieldValue('leadOwner', newValue ? newValue.id : '')}
                                        placeholder="Select Lead Owner"
                                        error={touched.leadOwner && !!errors.leadOwner}
                                        helperText={touched.leadOwner && errors.leadOwner}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                                    <CustomAutocomplete
                                        options={clientCompany}
                                        fieldLabel="Select Company"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={clientCompany.find((option) => option.id === values.clientCompanyId) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('clientCompanyId', newValue ? newValue.id : '')
                                        }
                                        placeholder="Select Company"
                                        error={touched.clientCompanyId && !!errors.clientCompanyId}
                                        helperText={touched.clientCompanyId && errors.clientCompanyId}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomAutocomplete
                                        options={titles}
                                        fieldLabel="Title"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={titles.find((option) => option.id === values.title) || null}
                                        onChange={(e, newValue) => setFieldValue('title', newValue ? newValue.id : '')}
                                        placeholder="Select Title"
                                        error={touched.title && !!errors.title}
                                        helperText={touched.title && errors.title}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomTextField
                                        fieldLabel="First Name"
                                        name="firstName"
                                        placeholder="Enter First Name"
                                        required={true}
                                        onChange={handleChange}
                                        value={values.firstName}
                                        error={touched.firstName && !!errors.firstName}
                                        helperText={touched.firstName && errors.firstName}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomTextField
                                        fieldLabel="Last Name"
                                        name="lastName"
                                        placeholder="Enter Last Name"
                                        required={true}
                                        onChange={handleChange}
                                        value={values.lastName}
                                        error={touched.lastName && !!errors.lastName}
                                        helperText={touched.lastName && errors.lastName}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomTextField
                                        fieldLabel="Email"
                                        name="email"
                                        placeholder="Enter Email"
                                        type="email"
                                        required={true}
                                        onChange={handleChange}
                                        value={values.email}
                                        error={touched.email && !!errors.email}
                                        helperText={touched.email && errors.email}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomTextField
                                        type='number'
                                        fieldLabel="Phone"
                                        placeholder="Enter Phone"
                                        name="phone"
                                        onChange={handleChange}
                                        value={values.phone}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                                    <CustomMobileField
                                        type="number"
                                        name="mobile"
                                        fieldLabel="Mobile"
                                        required={true}
                                        value={values.mobile}
                                        onChange={handleChange}
                                        placeholder="Enter Mobile"
                                        error={touched.mobile && !!errors.mobile}
                                        helperText={touched.mobile && errors.mobile}
                                        countryCode={conutries.find((c) => c.id === values.phonecodeId)}
                                        setFieldValue={setFieldValue}
                                    />

                                </Grid>


                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomAutocomplete
                                        options={leadSource}
                                        fieldLabel="Select Source"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={leadSource.find((option) => option.id === values.leadSourceId) || null}
                                        onChange={(e, newValue) => setFieldValue('leadSourceId', newValue ? newValue.id : '')}
                                        placeholder="Select Source"
                                        error={touched.leadSourceId && !!errors.leadSourceId}
                                        helperText={touched.leadSourceId && errors.leadSourceId}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomAutocomplete
                                        options={leadStatus}
                                        fieldLabel="Select Lead Status"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={leadStatus.find((option) => option.id === values.leadStatusId) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('leadStatusId', newValue ? newValue.id : '')
                                        }
                                        placeholder="Select Lead Status"
                                        error={touched.leadStatusId && !!errors.leadStatusId}
                                        helperText={touched.leadStatusId && errors.leadStatusId}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomAutocomplete
                                        options={industryType}
                                        fieldLabel="Select Industry"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={industryType.find((option) => option.id === values.industry) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('industry', newValue ? newValue.id : '')
                                        }
                                        placeholder="Select Industry"
                                        error={touched.industry && !!errors.industry}
                                        helperText={touched.industry && errors.industry}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomTextField
                                        fieldLabel="Number of Employees"
                                        name="numberOfEmployees"
                                        placeholder="Enter Number of Employees"
                                        type="number"
                                        onChange={handleChange}
                                        value={values.numberOfEmployees}

                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomTextField
                                        fieldLabel="Annual Revenue"
                                        placeholder="Enter Annual Revenue"
                                        name="annualRevenue"
                                        type="number"
                                        onChange={handleChange}
                                        value={values.annualRevenue}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                                    <CustomAutocomplete
                                        options={rating}
                                        fieldLabel="Select Rating"
                                        getOptionLabel={(option) => option.title}
                                        value={rating.find((option) => option.id === values.rating) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('rating', newValue ? newValue.id : '')
                                        }
                                        placeholder="Select Rating"

                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomTextField
                                        name="expectedDate"
                                        fieldLabel="Expected Date"
                                        required={true}
                                        type="date"
                                        value={values.expectedDate}
                                        onChange={handleChange}
                                        placeholder="Enter Expected Date"
                                        error={touched.expectedDate && !!errors.expectedDate}
                                        helperText={touched.expectedDate && errors.expectedDate}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={values.emailOptOut === 1}
                                                onChange={(e) => setFieldValue('emailOptOut', e.target.checked ? 1 : 0)}
                                            />
                                        }
                                        label={t("Email Opt-Out")}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                                    <CustomAutocomplete
                                        options={businessGroup}
                                        fieldLabel="Business Group"
                                        getOptionLabel={(option) => option.title}
                                        value={businessGroup.find((option) => option.id === values.businessGroup) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('businessGroup', newValue ? newValue.id : '')
                                        }
                                        placeholder="Enter Business Group"
                                        required={true}
                                        error={touched.businessGroup && !!errors.businessGroup}
                                        helperText={touched.businessGroup && errors.businessGroup}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomTextField
                                        fieldLabel="Secondary Email"
                                        placeholder="Enter Secondary Email"
                                        name="secondaryEmail"
                                        type="email"
                                        onChange={handleChange}
                                        value={values.secondaryEmail}

                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomTextField
                                        fieldLabel="Street"
                                        placeholder="Enter Street"
                                        name="street"
                                        required={true}
                                        onChange={handleChange}
                                        value={values.street}
                                        error={touched.street && !!errors.street}
                                        helperText={touched.street && errors.street}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CustomAutocomplete
                                        options={countries}
                                        fieldLabel="Country"
                                        required
                                        getOptionLabel={(option) => option?.title || ""}
                                        onChange={(e, newValue) => handleChangeCountry(newValue, setFieldValue)}
                                        value={countries.find((c) => c.id === values.countryId) || null}
                                        placeholder="Select Country"
                                        error={touched.countryId && Boolean(errors.countryId)}
                                        helperText={touched.countryId && errors.countryId}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CustomAutocomplete
                                        options={states}
                                        fieldLabel="State"
                                        required
                                        getOptionLabel={(option) => option?.title || ""}
                                        onChange={(e, newValue) => handleChangeState(newValue, setFieldValue)}
                                        value={states.find((s) => s.id === values.stateId) || null}
                                        placeholder="Select State"
                                        error={touched.stateId && Boolean(errors.stateId)}
                                        helperText={touched.stateId && errors.stateId}
                                        disabled={!values.countryId}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CustomAutocomplete
                                        options={cities}
                                        fieldLabel="City"
                                        required
                                        getOptionLabel={(option) => option?.title || ""}
                                        onChange={(e, newValue) => setFieldValue("cityId", newValue?.id || "")}
                                        value={cities.find((c) => c.id === values.cityId) || null}
                                        placeholder="Select City"
                                        error={touched.cityId && Boolean(errors.cityId)}
                                        helperText={touched.cityId && errors.cityId}
                                        disabled={!values.stateId}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <CustomTextField
                                        type='number'
                                        fieldLabel="Zip Code"
                                        placeholder="Enter Zip Code"
                                        name="zipCode"
                                        onChange={handleChange}
                                        value={values.zipCode}

                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <CustomTextarea
                                        name="description"
                                        fieldLabel="Note"
                                        multiline
                                        rows={4}
                                        value={values.description}
                                        onChange={handleChange}
                                        placeholder="Enter Note"

                                    />
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
        </>
    );
};

export default UpdateLeads;

